import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

const CustomConfirmModal = ({ open, size, content, onCancel, onConfirm, closeModal, header, cancelButton, confirmButton }) => (
    <Modal open={open} className={size} data-testid="confirm-modal">
        {closeModal ? (
            <Modal.Header><span class="modal-header-span">{header}</span><i onClick={onCancel} className="close" title="close">&#x2716;</i></Modal.Header>
        ) : (<Modal.Header><span class="modal-header-span">{header}</span></Modal.Header>)}
        <Modal.Content>
            <div className="pl0 mt20">
                {content}
            </div>
        </Modal.Content>
        <Modal.Actions>
            <div className="pl0 mt20 txtCenter">
                <Button secondary onClick={onCancel}>{cancelButton}</Button>
                <Button secondary onClick={onConfirm}>{confirmButton}</Button>
            </div>
        </Modal.Actions>
    </Modal>
)

export default CustomConfirmModal;

